import { render, staticRenderFns } from "./CvPage.vue?vue&type=template&id=3dd156c5&lang=pug&"
import script from "./CvPage.vue?vue&type=script&lang=ts&"
export * from "./CvPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd156c5')) {
      api.createRecord('3dd156c5', component.options)
    } else {
      api.reload('3dd156c5', component.options)
    }
    module.hot.accept("./CvPage.vue?vue&type=template&id=3dd156c5&lang=pug&", function () {
      api.rerender('3dd156c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cvtool-pages/CvPage.vue"
export default component.exports